export const CLARIFICATION_ENVELOPE_PREFIX = '[LINE_CLARIFICATION_RESPONSE]'

export const isClarificationEnvelope = (text: string): boolean =>
  text.trimStart().startsWith(CLARIFICATION_ENVELOPE_PREFIX)

export const stripClarificationEnvelope = (text: string): string => {
  if (!isClarificationEnvelope(text)) return text
  const value = text.match(/^value:\s*(.+)$/m)?.[1]?.trim()
  return value || text
}
